module.exports = __webpack_public_path__ + "img/shoplogo.808b90df.svg";